export const displayDataMessage = {
  saveDraftDisplayDataSuccess: 'Labels successfully saved',
  publishDisplayDataSuccess: 'Labels successfully published',
  deleteDraftDisplayDataSuccess: 'Label successfully deleted',
  deleteDraftDisplayDataAssignmentsSuccess: 'Applied Label successfully deleted',
}